module.exports = __webpack_public_path__ + "static/SFMono-Medium-99497ab65b5b8a7e5c18b7b3edde5c85.woff2";